import styled from 'vue-styled-components';

import { GRAY, FLEX_CENTER, square } from '@/styles/common.styled';
import { FLEX_COLUMN_DIV, FLEX_DIV } from '@/styles/common.styled.component';

export const Header = styled(FLEX_DIV)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    background-color: ${GRAY(10)};
    padding: 11px 16px;
`;

export const Title = styled(FLEX_DIV)`
    ${FLEX_CENTER}
    padding: 0;
    margin: 0;

    svg {
        ${square(16)}
        margin-right: 8px;
    }

    h1 {
        flex: 1;
        color: ${GRAY(100)};
        font-size: 14px;
        font-weight: 500;
        margin-right: 6px;
    }
`;

export const Content = styled(FLEX_COLUMN_DIV)`
    width: 100%;
`;

export const Row = styled(FLEX_DIV)`
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    color: #080a0d;
    overflow: hidden;

    &:not(:last-child) {
        border-bottom: 1px solid #dfe3e5;
    }
`;

export const RowTitle = styled.span`
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0px;
    color: #080a0d;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;

    input {
        width: 280px;
        height: 34px;
        border-radius: 2px;
        border: 1px solid #bdc2c7;
        padding: 8px 12px;
        font-family: var(--font-family-primary);
        font-weight: 400;
        font-size: 13px;
        line-height: 100%;
        color: #080a0d;
        outline: none;

        /* Hide spinner buttons for number input */
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* For Firefox */
        &[type='number'] {
            -moz-appearance: textfield;
        }

        &::placeholder {
            color: #bdc2c7;
        }
    }
`;

export const ErrorText = styled.div`
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    color: #c72e2c;
    width: 280px;
`;

export const ComponentWrapper = styled(FLEX_COLUMN_DIV)`
    justify-content: space-between;
    align-items: center;

    border: 1px solid ${GRAY(20)};
    border-radius: 2px;
`;

export const ResetButton = styled.button`
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    letter-spacing: 0px;
    color: #0054c6;
    cursor: pointer;
    padding: 0;
`;
